var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { SelectAsync } from "@irati/ui/src/FormItem";
import id from "@irati/utils/id";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import loadCompanyValues from "@irati/companyvalues/apollo/query/LoadCompanyValues";
import TrophyImg from "@irati/ui/src/Trophy";
import { StyledTrophyWrapper } from "./styled";
import getCompanyValueSearchText from "./CompanyValuesSearchText";
var PROPERTY = "companyValues";
var MIN_SEARCH_COUNT = 3;
var SelectCompanyValue = /** @class */ (function (_super) {
    __extends(SelectCompanyValue, _super);
    function SelectCompanyValue(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (selectedCompanyValues) {
            var _a = _this.props, item = _a.item, onChange = _a.onChange;
            var values = selectedCompanyValues.map(function (v) { return v.uuid; });
            onChange(item, PROPERTY, values);
        };
        _this.handleInputChange = function (searchString) { return _this.setState({ searchString: searchString }); };
        _this.load = function () {
            return _this.getCompanyValues();
        };
        _this.getCompanyValues = function () {
            var params = {
                limit: 9999,
                tenantId: authentication.userTenant().uuid
            };
            return loadCompanyValues(params).then(function (_a) {
                var results = _a.results;
                return results;
            });
        };
        _this.search = function (option) {
            var searchString = _this.state.searchString;
            var companyValue = option.data;
            if (searchString) {
                var t = companyValue.tag.toLowerCase();
                return t.includes(searchString.toLowerCase());
            }
            return true;
        };
        _this.getPromptText = function () {
            var searchString = _this.state.searchString;
            var _a = _this.props, intl = _a.intl, hint = _a.hint, stringlength = _a.stringlength, underLimit = _a.underLimit;
            if (searchString && searchString.length >= MIN_SEARCH_COUNT) {
                return React.createElement(FormattedMessage, { id: stringlength });
            }
            return hint || React.createElement(FormattedMessage, { id: underLimit, values: { count: intl.formatNumber(MIN_SEARCH_COUNT) } });
        };
        _this.state = {
            searchString: ""
        };
        _this.load();
        return _this;
    }
    SelectCompanyValue.prototype.render = function () {
        var _this = this;
        var _a;
        var idNamespace = id(PROPERTY, this.props);
        var tenant = authentication.userTenant();
        var _b = this.props, defaultOptions = _b.defaultOptions, formatMessage = _b.formatMessage, item = _b.item, label = _b.label, isMulti = _b.isMulti, placeholder = _b.placeholder;
        var value = item.companyValues;
        if (isMulti && ((_a = item.companyValues) === null || _a === void 0 ? void 0 : _a.length)) {
            value = item.companyValues.map(function (valueId) {
                return {
                    uuid: valueId
                };
            });
        }
        return (React.createElement(SelectAsync, __assign({}, this.props, { autoComplete: false, defaultOptions: defaultOptions, id: idNamespace, filterOption: function (option) { return _this.search(option); }, label: formatMessage({ id: label }, { name: tenant.public_name }), loadOptions: this.load, isMulti: isMulti, name: idNamespace, onChange: this.handleChange, onInputChange: this.handleInputChange, components: {
                OptionIcon: function (_a) {
                    var icon = _a.icon;
                    return (icon ? React.createElement(StyledTrophyWrapper, null,
                        React.createElement(TrophyImg, { isSet: true, size: "30px", src: icon.href })) : null);
                },
                NoOptionsMessage: getCompanyValueSearchText(this.getPromptText())
            }, placeholder: placeholder, value: value })));
    };
    SelectCompanyValue.defaultProps = {
        defaultOptions: true,
        id: "company-values-selector",
        label: "platform.fields.companyValue.label",
        labelKey: "tag",
        isMulti: true,
        placeholder: "platform.fields.companyValue.placeholder",
        stringlength: "platform.fields.companyValue.noneFound",
        underLimit: "platform.fields.companyValue.underCharLimit",
        valueKey: "uuid"
    };
    return SelectCompanyValue;
}(Component));
export default injectIntl(SelectCompanyValue);
